"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hanghae = void 0;
exports.hanghae = {
    orangeRed120: "#C20000",
    orangeRed100: "#F50000",
    orangeRed60: "#FF5C5C",
    orangeRed40: "#FF8F8F",
    orangeRed20: "#FFC2C2",
    orangeRed0: "#FFEBEB",
    darkRed100: "#5C0000",
    darkRed80: "#8F1919",
    indigo100: "#1C2A40",
    indigo80: "#2B4162",
    indigo60: "#4B71AA",
    indigo40: "#B1C3DD",
    indigo20: "#D4DEEC",
    indigo10: "#F1F4F9",
};
//# sourceMappingURL=hanghae.js.map